import { render } from "./ModelSelector.vue?vue&type=template&id=579bae9f&scoped=true"
import script from "./ModelSelector.vue?vue&type=script&lang=js"
export * from "./ModelSelector.vue?vue&type=script&lang=js"

import "./ModelSelector.vue?vue&type=style&index=0&id=579bae9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579bae9f"]])

export default __exports__